var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selectButton",on:{"click":_vm.callBackClick}},[_c('p',[_c('span',[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('span',[_vm._v(" "+_vm._s(_vm.summary)+" ")])]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }